'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Upload = require('./Upload');

var _Upload2 = _interopRequireDefault(_Upload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Dragger = function (_React$Component) {
    (0, _inherits3["default"])(Dragger, _React$Component);

    function Dragger() {
        (0, _classCallCheck3["default"])(this, Dragger);
        return (0, _possibleConstructorReturn3["default"])(this, _React$Component.apply(this, arguments));
    }

    Dragger.prototype.render = function render() {
        var props = this.props;

        return _react2["default"].createElement(_Upload2["default"], (0, _extends3["default"])({}, props, { type: 'drag', style: (0, _extends3["default"])({}, props.style, { height: props.height }) }));
    };

    return Dragger;
}(_react2["default"].Component);

exports["default"] = Dragger;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/upload/Dragger.tsx
 ** module id = 655
 ** module chunks = 0 1
 **/